import { Link } from "react-router-dom";
import MicroLabel from "@/components/base/MicroLabel";

interface OrderTypeCardProps {
  slug: string;
  name: string;
  category: string;
  summary: string;
  tagline: string;
  index?: string;
}

export default function OrderTypeCard({
  slug,
  name,
  category,
  summary,
  tagline,
  index,
}: OrderTypeCardProps) {
  return (
    <Link
      to={`/${slug}`}
      className="group relative flex flex-col h-full border-2 border-foreground-950 bg-background-50 p-5 md:p-6 transition-colors duration-200 hover:bg-foreground-950 cursor-pointer"
    >
      <div className="flex items-start justify-between gap-3 border-b-2 border-foreground-950/15 pb-4">
        {index && (
          <span className="font-heading font-black text-4xl leading-[0.8] text-stroke text-foreground-950 transition-colors group-hover:text-primary-500" aria-hidden="true">
            {index}
          </span>
        )}
        <span className="mt-0.5">
          <MicroLabel tone="muted" className="transition-colors group-hover:text-background-300">
            Core type
          </MicroLabel>
        </span>
      </div>

      <MicroLabel tone="accent" className="mt-5 transition-colors group-hover:text-primary-500">
        {category}
      </MicroLabel>
      <h3 className="mt-2 font-heading font-black uppercase tracking-tight leading-[0.95] text-2xl text-foreground-950 transition-colors group-hover:text-background-50">
        {name}
      </h3>
      <p className="mt-3 text-sm font-medium text-foreground-700 transition-colors group-hover:text-background-200">
        {tagline}
      </p>
      <p className="mt-3 text-sm leading-relaxed text-foreground-600 flex-1 transition-colors group-hover:text-background-300">
        {summary}
      </p>

      <MicroLabel className="mt-6 transition-colors group-hover:text-primary-500">
        Read breakdown
        <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
      </MicroLabel>
    </Link>
  );
}